import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import { saveAs } from 'file-saver';
import { take, map, takeUntil } from 'rxjs/operators';
import * as i1 from '@angular/common/http';
import { Subject } from 'rxjs';
import { environment } from 'environment-configurations';
import * as i3 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomErrorToastComponent } from 'custom-error-toast';
import * as i2 from 'custom-button-action';
import * as i4 from 'ngx-toastr';
import * as i5 from 'cache-country-list';
import * as i6 from '@angular/common';
import * as i7 from 'primeng/radiobutton';
import * as i8 from 'primeng/dropdown';
import * as i9 from 'primeng/fileupload';
import * as i10 from 'lib-add-new-employee';
import { LibAddNewEmployeeModule } from 'lib-add-new-employee';
import * as i11 from 'primeng/button';
import * as i12 from 'primeng/table';
import * as i13 from 'primeng/api';
import * as i14 from 'primeng/tooltip';
import { PrimengLibraryModule } from 'primeng-library';

class BulkUploadDashboardService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.editFlowflag = '';
    }
    downloadDocuments(path, fileName) {
        this.httpClient.get(path, { responseType: "arraybuffer" })
            .pipe(take(1))
            .subscribe(file => {
            const blob = new Blob([file], { type: 'text/csv' });
            saveAs(blob, fileName);
        });
    }
    uploadDocument(moduleId, payload, param1, param2) {
        return this.httpClient.post(`/vd/formBuilder/${param1}/module/${moduleId}/upload/${param2}`, payload).pipe(map((response) => {
            if (response) {
                return response;
            }
        }));
    }
    addApplicant(UploadId, param, payload) {
        return this.httpClient.post(`/vd/formBuilder/${param}/bulkupload/${UploadId}/save`, payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    addSupplier(payload) {
        return this.httpClient.post('/vd/fb/save/suppliers', payload).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadTemplate() {
        return this.httpClient.get('/vd/formBuilder/talentpool/bulkupload/template/download').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadSupplierTemplate() {
        return this.httpClient.get('/vd/formBuilder/supplier/bulkupload/template/download').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    downloadEmployeeTemplate() {
        return this.httpClient.get('/vd/formBuilder/onbEmp/bulkupload/template/download').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getErrorEditDetails(uploadId) {
        return this.httpClient.get(`/vd/formBuilder/supplier/bulkupload/supplier/${uploadId}/erroredit/details`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getEmpErrorEditDetails(uploadId) {
        return this.httpClient.get(`/vd/formBuilder/employee/bulkupload/employee/${uploadId}/erroredit/details`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    retrieveDocument(uploadId, param, param2) {
        return this.httpClient.get(`/vd/formBuilder/${param}/bulkupload/${uploadId}/${param2}`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    deleteApplicant(errorID, param) {
        return this.httpClient.delete(`/vd/formBuilder/${param}/bulkupload/${errorID}/delete`).pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    editErrorDocument(errorId) {
        return this.httpClient.get('/vd/formBuilder/supplier/bulkupload/supplier/' + errorId + '/details').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    editEmpErrorDocument(errorId) {
        return this.httpClient.get('/vd/formBuilder/employee/bulkupload/employee/' + errorId + '/details').pipe(map((response) => {
            if (response && response.status === 200) {
                return response;
            }
        }));
    }
    getSupplierList() {
        return this.httpClient.get(`/vd/formBuilder/get/supplierList/info`);
    }
}
BulkUploadDashboardService.ɵfac = function BulkUploadDashboardService_Factory(t) { return new (t || BulkUploadDashboardService)(i0.ɵɵinject(i1.HttpClient)); };
BulkUploadDashboardService.ɵprov = i0.ɵɵdefineInjectable({ token: BulkUploadDashboardService, factory: BulkUploadDashboardService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkUploadDashboardService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

const _c0 = ["fileUpload"];
function BulkUploadDashboardComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12);
    i0.ɵɵelementStart(1, "h5");
    i0.ɵɵtext(2, "Upload list of resume documents");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_h6_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 13);
    i0.ɵɵtext(1, "How do you want to include a new Candidate?");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_h6_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 13);
    i0.ɵɵtext(1, "How would you like to add the suppliers?");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_h6_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 13);
    i0.ɵɵtext(1, "Upload Employees");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_7_p_radioButton_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 18);
    i0.ɵɵlistener("ngModelChange", function BulkUploadDashboardComponent_div_7_p_radioButton_1_Template_p_radioButton_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(2); return ctx_r17.CSV = $event; })("onClick", function BulkUploadDashboardComponent_div_7_p_radioButton_1_Template_p_radioButton_onClick_0_listener() { i0.ɵɵrestoreView(_r18); const ctx_r19 = i0.ɵɵnextContext(2); return ctx_r19.radiovalue(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r16 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", i_r16.value)("label", i_r16.label)("ngModel", ctx_r13.CSV)("inputId", i_r16.inputId);
} }
function BulkUploadDashboardComponent_div_7_p_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 19);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_7_p_2_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r21); const ctx_r20 = i0.ɵɵnextContext(2); return ctx_r20.downloadTemplateFile(); });
    i0.ɵɵelementStart(1, "i");
    i0.ɵɵtext(2, "Download Excel Template ");
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
const _c1 = function () { return { "width": "100%" }; };
function BulkUploadDashboardComponent_div_7_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelementStart(1, "p", 22);
    i0.ɵɵtext(2, "Suppliers");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 23);
    i0.ɵɵlistener("onChange", function BulkUploadDashboardComponent_div_7_div_3_Template_p_dropdown_onChange_3_listener($event) { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.onChangeSupplier($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction0(3, _c1));
    i0.ɵɵproperty("options", ctx_r15.supplierList);
} }
function BulkUploadDashboardComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, BulkUploadDashboardComponent_div_7_p_radioButton_1_Template, 1, 4, "p-radioButton", 15);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_7_p_2_Template, 4, 0, "p", 16);
    i0.ɵɵtemplate(3, BulkUploadDashboardComponent_div_7_div_3_Template, 4, 4, "div", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r4.radios);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.fileFlag);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.fileFlag);
} }
function BulkUploadDashboardComponent_div_8_p_radioButton_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 18);
    i0.ɵɵlistener("ngModelChange", function BulkUploadDashboardComponent_div_8_p_radioButton_1_Template_p_radioButton_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(2); return ctx_r27.CSV = $event; })("onClick", function BulkUploadDashboardComponent_div_8_p_radioButton_1_Template_p_radioButton_onClick_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r29 = i0.ɵɵnextContext(2); return ctx_r29.radiovalue(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r26 = ctx.$implicit;
    const ctx_r24 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", i_r26.value)("label", i_r26.label)("ngModel", ctx_r24.CSV)("inputId", i_r26.inputId);
} }
function BulkUploadDashboardComponent_div_8_p_2_Template(rf, ctx) { if (rf & 1) {
    const _r31 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 19);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_8_p_2_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r31); const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.downloadSupplierTemplateFile(); });
    i0.ɵɵelementStart(1, "i");
    i0.ɵɵtext(2, "Download Excel Template ");
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, BulkUploadDashboardComponent_div_8_p_radioButton_1_Template, 1, 4, "p-radioButton", 15);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_8_p_2_Template, 4, 0, "p", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r5.supplierRadios);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.fileFlag);
} }
function BulkUploadDashboardComponent_div_9_p_radioButton_1_Template(rf, ctx) { if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-radioButton", 18);
    i0.ɵɵlistener("ngModelChange", function BulkUploadDashboardComponent_div_9_p_radioButton_1_Template_p_radioButton_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r36); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.CSV = $event; })("onClick", function BulkUploadDashboardComponent_div_9_p_radioButton_1_Template_p_radioButton_onClick_0_listener() { i0.ɵɵrestoreView(_r36); const ctx_r37 = i0.ɵɵnextContext(2); return ctx_r37.radiovalue(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r34 = ctx.$implicit;
    const ctx_r32 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("value", i_r34.value)("label", i_r34.label)("ngModel", ctx_r32.CSV)("inputId", i_r34.inputId);
} }
function BulkUploadDashboardComponent_div_9_p_2_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 19);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_9_p_2_Template_p_click_0_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(2); return ctx_r38.downloadEmployeeTemplateFile(); });
    i0.ɵɵelementStart(1, "i");
    i0.ɵɵtext(2, "Download Template ");
    i0.ɵɵelement(3, "i", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵtemplate(1, BulkUploadDashboardComponent_div_9_p_radioButton_1_Template, 1, 4, "p-radioButton", 15);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_9_p_2_Template, 4, 0, "p", 16);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r6.employerRadios);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.fileFlag);
} }
function BulkUploadDashboardComponent_label_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 24);
    i0.ɵɵtext(1, "Upload File:");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_p_fileUpload_12_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-fileUpload", 25);
    i0.ɵɵlistener("onSelect", function BulkUploadDashboardComponent_p_fileUpload_12_Template_p_fileUpload_onSelect_0_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(); return ctx_r40.FileUpload($event, "bulk"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵproperty("multiple", true)("disabled", ctx_r8.disableFileUpload)("auto", true);
} }
function BulkUploadDashboardComponent_p_fileUpload_13_Template(rf, ctx) { if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-fileUpload", 26, 27);
    i0.ɵɵlistener("uploadHandler", function BulkUploadDashboardComponent_p_fileUpload_13_Template_p_fileUpload_uploadHandler_0_listener($event) { i0.ɵɵrestoreView(_r44); const ctx_r43 = i0.ɵɵnextContext(); return ctx_r43.FileUpload($event, "single"); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵproperty("disabled", ctx_r9.disableFileUpload)("auto", true);
} }
function BulkUploadDashboardComponent_div_14_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_14_span_5_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r56); const ctx_r55 = i0.ɵɵnextContext(2); return ctx_r55.closeForm(); });
    i0.ɵɵtext(1, "\u2715");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Supplier Name is Required ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Please enter a valid Name ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_option_22_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 48);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const data_r57 = ctx.$implicit;
    i0.ɵɵproperty("value", data_r57.phoneCode);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2("", data_r57.countryName, " - ", data_r57.phoneCode, " ");
} }
function BulkUploadDashboardComponent_div_14_span_27_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Please enter a valid phone number ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_34_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Email is required ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_35_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Please enter a valid email address ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_41_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Location is Required ");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_14_span_42_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, " Please enter a valid Location ");
    i0.ɵɵelementEnd();
} }
const _c2 = function (a0) { return { "im-input-error": a0 }; };
const _c3 = function (a0) { return { "invalidBtn": a0 }; };
function BulkUploadDashboardComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelement(1, "hr", 28);
    i0.ɵɵelementStart(2, "div", 29);
    i0.ɵɵelementStart(3, "h6", 30);
    i0.ɵɵtext(4, "Enter Supplier Details");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, BulkUploadDashboardComponent_div_14_span_5_Template, 2, 0, "span", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "form", 32, 33);
    i0.ɵɵlistener("ngSubmit", function BulkUploadDashboardComponent_div_14_Template_form_ngSubmit_6_listener() { i0.ɵɵrestoreView(_r59); const ctx_r58 = i0.ɵɵnextContext(); return ctx_r58.saveSupplierData(); });
    i0.ɵɵelementStart(8, "div", 34);
    i0.ɵɵelementStart(9, "div", 35);
    i0.ɵɵelementStart(10, "p", 36);
    i0.ɵɵtext(11, "Supplier Name");
    i0.ɵɵelementStart(12, "sup");
    i0.ɵɵtext(13, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(14, "input", 37);
    i0.ɵɵtemplate(15, BulkUploadDashboardComponent_div_14_span_15_Template, 2, 0, "span", 38);
    i0.ɵɵtemplate(16, BulkUploadDashboardComponent_div_14_span_16_Template, 2, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 34);
    i0.ɵɵelementStart(18, "div", 35);
    i0.ɵɵelementStart(19, "p", 39);
    i0.ɵɵtext(20, "Phone Code");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "select", 40);
    i0.ɵɵlistener("change", function BulkUploadDashboardComponent_div_14_Template_select_change_21_listener($event) { i0.ɵɵrestoreView(_r59); const ctx_r60 = i0.ɵɵnextContext(); return ctx_r60.valueChange($event); });
    i0.ɵɵtemplate(22, BulkUploadDashboardComponent_div_14_option_22_Template, 2, 3, "option", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 35);
    i0.ɵɵelementStart(24, "p", 36);
    i0.ɵɵtext(25, "Daytime telephone no.");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(26, "input", 42);
    i0.ɵɵtemplate(27, BulkUploadDashboardComponent_div_14_span_27_Template, 2, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 35);
    i0.ɵɵelementStart(29, "p", 36);
    i0.ɵɵtext(30, "Email");
    i0.ɵɵelementStart(31, "sup");
    i0.ɵɵtext(32, "*");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(33, "input", 43);
    i0.ɵɵtemplate(34, BulkUploadDashboardComponent_div_14_span_34_Template, 2, 0, "span", 38);
    i0.ɵɵtemplate(35, BulkUploadDashboardComponent_div_14_span_35_Template, 2, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(36, "div", 34);
    i0.ɵɵelementStart(37, "div", 35);
    i0.ɵɵelementStart(38, "p", 36);
    i0.ɵɵtext(39, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(40, "input", 44);
    i0.ɵɵtemplate(41, BulkUploadDashboardComponent_div_14_span_41_Template, 2, 0, "span", 38);
    i0.ɵɵtemplate(42, BulkUploadDashboardComponent_div_14_span_42_Template, 2, 0, "span", 38);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(43, "button", 45);
    i0.ɵɵtext(44, " Save ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngIf", ctx_r10.isErrorEdit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formGroup", ctx_r10.supplierDetailsForm);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c2, ctx_r10.supplierDetailsForm.get("supplierName").touched && (ctx_r10.supplierDetailsForm.get("supplierName").errors == null ? null : ctx_r10.supplierDetailsForm.get("supplierName").errors.required)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("supplierName").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("supplierName").errors == null ? null : ctx_r10.supplierDetailsForm.get("supplierName").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("supplierName").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("supplierName").errors == null ? null : ctx_r10.supplierDetailsForm.get("supplierName").errors.pattern));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngForOf", ctx_r10.DataArr);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c2, (ctx_r10.supplierDetailsForm.get("phoneNumber").touched || ctx_r10.submitted) && ((ctx_r10.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx_r10.supplierDetailsForm.get("phoneNumber").errors.required) || (ctx_r10.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx_r10.supplierDetailsForm.get("phoneNumber").errors.pattern))));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("phoneNumber").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("phoneNumber").errors == null ? null : ctx_r10.supplierDetailsForm.get("phoneNumber").errors.pattern));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c2, (ctx_r10.supplierDetailsForm.get("communicationEmailId").touched || ctx_r10.submitted) && ((ctx_r10.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx_r10.supplierDetailsForm.get("communicationEmailId").errors.required) || (ctx_r10.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx_r10.supplierDetailsForm.get("communicationEmailId").errors.email))));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("communicationEmailId").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx_r10.supplierDetailsForm.get("communicationEmailId").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("communicationEmailId").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("communicationEmailId").errors == null ? null : ctx_r10.supplierDetailsForm.get("communicationEmailId").errors.email));
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c2, ctx_r10.supplierDetailsForm.get("location").touched && (ctx_r10.supplierDetailsForm.get("location").errors == null ? null : ctx_r10.supplierDetailsForm.get("location").errors.required)));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("location").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("location").errors == null ? null : ctx_r10.supplierDetailsForm.get("location").errors.required));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r10.supplierDetailsForm.get("location").touched || ctx_r10.submitted) && (ctx_r10.supplierDetailsForm.get("location").errors == null ? null : ctx_r10.supplierDetailsForm.get("location").errors.pattern));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r10.supplierDetailsForm.invalid)("ngClass", i0.ɵɵpureFunction1(24, _c3, ctx_r10.supplierDetailsForm.invalid));
} }
function BulkUploadDashboardComponent_div_15_span_1_Template(rf, ctx) { if (rf & 1) {
    const _r63 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_15_span_1_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r63); const ctx_r62 = i0.ɵɵnextContext(2); return ctx_r62.closeForm(); });
    i0.ɵɵtext(1, "\u2715");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r65 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49);
    i0.ɵɵtemplate(1, BulkUploadDashboardComponent_div_15_span_1_Template, 2, 0, "span", 31);
    i0.ɵɵelementStart(2, "lib-add-new-employee", 50);
    i0.ɵɵlistener("formSaved", function BulkUploadDashboardComponent_div_15_Template_lib_add_new_employee_formSaved_2_listener() { i0.ɵɵrestoreView(_r65); const ctx_r64 = i0.ɵɵnextContext(); return ctx_r64.saveEmployeeData(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r11.isErrorEdit);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("employeeDetails", ctx_r11.getEmployeeDetails);
} }
function BulkUploadDashboardComponent_div_16_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r66 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r66.fileName);
} }
function BulkUploadDashboardComponent_div_16_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "p");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const file_r73 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(file_r73.name);
} }
function BulkUploadDashboardComponent_div_16_span_29_Template(rf, ctx) { if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 64);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_span_29_Template_span_click_0_listener() { i0.ɵɵrestoreView(_r75); const ctx_r74 = i0.ɵɵnextContext(2); return ctx_r74.clear(); });
    i0.ɵɵelementStart(1, "i");
    i0.ɵɵtext(2, "Clear All");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_16_div_30_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Employee Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Position Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Contact No.");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Email ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Error Msg");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_16_div_30_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r80 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 59);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 69);
    i0.ɵɵelementStart(14, "div", 70);
    i0.ɵɵelementStart(15, "div", 71);
    i0.ɵɵelementStart(16, "button", 72);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_30_ng_template_3_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r80); const candidate_r78 = ctx.$implicit; const ctx_r79 = i0.ɵɵnextContext(3); return ctx_r79.editDocument(candidate_r78); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 71);
    i0.ɵɵelementStart(18, "button", 73);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_30_ng_template_3_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r80); const candidate_r78 = ctx.$implicit; const ctx_r81 = i0.ɵɵnextContext(3); return ctx_r81.deleteDocument(candidate_r78); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const candidate_r78 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.employeeName) ? candidate_r78.employeeName : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.position) ? candidate_r78.position : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.contactNumber) ? candidate_r78.contactNumber : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.emailId) ? candidate_r78.emailId : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.location) ? candidate_r78.location : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r78 == null ? null : candidate_r78.errorMessage) ? candidate_r78.errorMessage : "N/A");
} }
const _c4 = function () { return { "min-width": "50rem" }; };
const _c5 = function () { return [25, 50, 100]; };
function BulkUploadDashboardComponent_div_16_div_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "p-table", 66);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_16_div_30_ng_template_2_Template, 15, 0, "ng-template", 67);
    i0.ɵɵtemplate(3, BulkUploadDashboardComponent_div_16_div_30_ng_template_3_Template, 19, 6, "ng-template", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r69 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r69.getUploadFilesResponse == null ? null : ctx_r69.getUploadFilesResponse.errorDetails)("tableStyle", i0.ɵɵpureFunction0(6, _c4))("paginator", true)("rows", 25)("showCurrentPageReport", true)("rowsPerPageOptions", i0.ɵɵpureFunction0(7, _c5));
} }
function BulkUploadDashboardComponent_div_16_div_31_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Suppliers Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "Communication Email ID");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Phone Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Location");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Error Msg");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_16_div_31_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r86 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td", 74);
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td", 69);
    i0.ɵɵelementStart(12, "div", 70);
    i0.ɵɵelementStart(13, "div", 71);
    i0.ɵɵelementStart(14, "button", 72);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_31_ng_template_3_Template_button_click_14_listener() { i0.ɵɵrestoreView(_r86); const candidate_r84 = ctx.$implicit; const ctx_r85 = i0.ɵɵnextContext(3); return ctx_r85.editSupplierDocument(candidate_r84); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 71);
    i0.ɵɵelementStart(16, "button", 73);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_31_ng_template_3_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r86); const candidate_r84 = ctx.$implicit; const ctx_r87 = i0.ɵɵnextContext(3); return ctx_r87.deleteDocument(candidate_r84); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const candidate_r84 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r84 == null ? null : candidate_r84.supplierName) ? candidate_r84.supplierName : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r84 == null ? null : candidate_r84.communicationEmailId) ? candidate_r84.communicationEmailId : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", (candidate_r84 == null ? null : candidate_r84.phoneCode) ? "+" + candidate_r84.phoneCode : "", " ", (candidate_r84 == null ? null : candidate_r84.phoneNumber) ? candidate_r84.phoneNumber : "N/A", "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r84 == null ? null : candidate_r84.location) ? candidate_r84.location : "N/A");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (candidate_r84 == null ? null : candidate_r84.errorMessage) ? "sup-error" : "no-error");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((candidate_r84 == null ? null : candidate_r84.errorMessage) ? candidate_r84.errorMessage : "N/A");
} }
function BulkUploadDashboardComponent_div_16_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "p-table", 66);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_16_div_31_ng_template_2_Template, 13, 0, "ng-template", 67);
    i0.ɵɵtemplate(3, BulkUploadDashboardComponent_div_16_div_31_ng_template_3_Template, 17, 7, "ng-template", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r70 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r70.getUploadFilesResponse == null ? null : ctx_r70.getUploadFilesResponse.errorDetails)("tableStyle", i0.ɵɵpureFunction0(6, _c4))("paginator", true)("rows", 25)("showCurrentPageReport", true)("rowsPerPageOptions", i0.ɵɵpureFunction0(7, _c5));
} }
function BulkUploadDashboardComponent_div_16_div_32_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "th");
    i0.ɵɵtext(2, "Title");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "th");
    i0.ɵɵtext(4, "First Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "th");
    i0.ɵɵtext(6, "Last Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "th");
    i0.ɵɵtext(8, "Middle Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "th");
    i0.ɵɵtext(10, "Personal Email");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "th");
    i0.ɵɵtext(12, "Mobile Number");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "th");
    i0.ɵɵtext(14, "Error Msg");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "th");
    i0.ɵɵtext(16, "Actions");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_16_div_32_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r92 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "td");
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "td");
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "td");
    i0.ɵɵtext(10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "td");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "td", 74);
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "td", 69);
    i0.ɵɵelementStart(16, "div", 70);
    i0.ɵɵelementStart(17, "div", 71);
    i0.ɵɵelementStart(18, "button", 72);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_32_ng_template_3_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r92); const candidate_r90 = ctx.$implicit; const ctx_r91 = i0.ɵɵnextContext(3); return ctx_r91.editEmployeeDocument(candidate_r90); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 71);
    i0.ɵɵelementStart(20, "button", 73);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_div_32_ng_template_3_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r92); const candidate_r90 = ctx.$implicit; const ctx_r93 = i0.ɵɵnextContext(3); return ctx_r93.deleteDocument(candidate_r90); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const candidate_r90 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.title) ? candidate_r90.title : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.firstName) ? candidate_r90.firstName : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.lastName) ? candidate_r90.lastName : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.middleName) ? candidate_r90.middleName : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.personalEmail) ? candidate_r90.personalEmail : "N/A");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.mobileNumber) ? "+" + candidate_r90.mobileNumber : "N/A");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", (candidate_r90 == null ? null : candidate_r90.errorMessage) ? "sup-error" : "no-error");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate((candidate_r90 == null ? null : candidate_r90.errorMessage) ? candidate_r90.errorMessage : "N/A");
} }
function BulkUploadDashboardComponent_div_16_div_32_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 65);
    i0.ɵɵelementStart(1, "p-table", 66);
    i0.ɵɵtemplate(2, BulkUploadDashboardComponent_div_16_div_32_ng_template_2_Template, 17, 0, "ng-template", 67);
    i0.ɵɵtemplate(3, BulkUploadDashboardComponent_div_16_div_32_ng_template_3_Template, 21, 8, "ng-template", 68);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r71 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("value", ctx_r71.getUploadFilesResponse == null ? null : ctx_r71.getUploadFilesResponse.errorDetails)("tableStyle", i0.ɵɵpureFunction0(6, _c4))("paginator", true)("rows", 25)("showCurrentPageReport", true)("rowsPerPageOptions", i0.ɵɵpureFunction0(7, _c5));
} }
function BulkUploadDashboardComponent_div_16_button_35_Template(rf, ctx) { if (rf & 1) {
    const _r95 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 75);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_button_35_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r95); const ctx_r94 = i0.ɵɵnextContext(2); return ctx_r94.deleteFile(); });
    i0.ɵɵtext(1, "Clear");
    i0.ɵɵelementEnd();
} }
function BulkUploadDashboardComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵelementStart(2, "h6", 13);
    i0.ɵɵtext(3, "Upload Summary");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p");
    i0.ɵɵtext(5, "You have uploaded : ");
    i0.ɵɵtemplate(6, BulkUploadDashboardComponent_div_16_span_6_Template, 2, 1, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, BulkUploadDashboardComponent_div_16_ng_container_7_Template, 3, 1, "ng-container", 52);
    i0.ɵɵelementStart(8, "div", 53);
    i0.ɵɵelementStart(9, "div", 54);
    i0.ɵɵelementStart(10, "div", 55);
    i0.ɵɵelementStart(11, "span");
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "span");
    i0.ɵɵtext(14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 56);
    i0.ɵɵelementStart(16, "span");
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "span");
    i0.ɵɵtext(19, "SUCCESSFULLY UPLOADED");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 57);
    i0.ɵɵelementStart(21, "span");
    i0.ɵɵtext(22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "span");
    i0.ɵɵtext(24, "FAILED UPLOADED");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "p", 58);
    i0.ɵɵelementStart(26, "span", 59);
    i0.ɵɵtext(27);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(28, " found during upload.");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(29, BulkUploadDashboardComponent_div_16_span_29_Template, 3, 0, "span", 60);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(30, BulkUploadDashboardComponent_div_16_div_30_Template, 4, 8, "div", 61);
    i0.ɵɵtemplate(31, BulkUploadDashboardComponent_div_16_div_31_Template, 4, 8, "div", 61);
    i0.ɵɵtemplate(32, BulkUploadDashboardComponent_div_16_div_32_Template, 4, 8, "div", 61);
    i0.ɵɵelementStart(33, "div");
    i0.ɵɵelementStart(34, "button", 62);
    i0.ɵɵlistener("click", function BulkUploadDashboardComponent_div_16_Template_button_click_34_listener() { i0.ɵɵrestoreView(_r97); const ctx_r96 = i0.ɵɵnextContext(); return ctx_r96.saveUploadDetails(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(35, BulkUploadDashboardComponent_div_16_button_35_Template, 2, 0, "button", 63);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngIf", ctx_r12.fileName);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r12.uploadedFiles);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) === "Manage Suppliers" ? (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalUploadedSupplierFiles) || "0" : (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) === "Onboarded Employee List" ? (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalUploadedEmployeeFiles) || "0" : (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalUploadedResumes) || "0", " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) === "Onboarded Employee List" ? "TOTAL RECORD(S)" : "TOTAL UPLOADED");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate((ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalSuccess) ? ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalSuccess : "0");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate((ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail) ? ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail : "0");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1("", (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.errorDetails) ? ctx_r12.getUploadFilesResponse.errorDetails.length : "0", " Errors ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail) !== 0 && (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) !== "Onboarded Employee List");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) !== "Manage Suppliers" && (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) !== "Onboarded Employee List" && (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail) !== 0 && ctx_r12.getUploadFilesResponse);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) === "Manage Suppliers" && (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail) !== 0 && ctx_r12.getUploadFilesResponse);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", (ctx_r12.formBuilderInfo == null ? null : ctx_r12.formBuilderInfo.formName) === "Onboarded Employee List" && (ctx_r12.getUploadFilesResponse == null ? null : ctx_r12.getUploadFilesResponse.totalFail) !== 0 && ctx_r12.getUploadFilesResponse);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("disabled", false || ctx_r12.hasEmailError());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.showSummary && ctx_r12.fileFlag && !ctx_r12.showEditForm);
} }
class BulkUploadDashboardComponent {
    constructor(bulkUploadDashboardService, customButtonActionService, supplierDetailsFormBuilder, toastr, cc, ch) {
        this.bulkUploadDashboardService = bulkUploadDashboardService;
        this.customButtonActionService = customButtonActionService;
        this.supplierDetailsFormBuilder = supplierDetailsFormBuilder;
        this.toastr = toastr;
        this.cc = cc;
        this.ch = ch;
        this.observableSubscription$ = new Subject();
        this.subscription = [];
        this.fileFlag = true;
        this.uploadedFiles = [];
        this.disableFileUpload = false;
        this.submitted = false;
        this.showEditForm = false;
        this.showSummary = false;
        this.radios = [
            {
                value: 'CSV',
                label: 'Upload CSV file with multiple Candidate data',
                inputId: 1
            },
            {
                value: 'multiPart',
                label: 'Upload multiple resumes together (.doc, .docx and .pdf format)',
                inputId: 2
            }
        ];
        this.supplierRadios = [
            {
                value: 'CSV',
                label: 'Upload Excel Sheet',
                inputId: 1
            },
            {
                value: 'manual',
                label: 'Add Manually',
                inputId: 2
            }
        ];
        this.employerRadios = [
            {
                value: 'CSV',
                label: 'Upload CSV file with multiple Candidate data',
                inputId: 1
            }
        ];
        this.isErrorEdit = false;
    }
    ngOnInit() {
        this.getModuleId = sessionStorage.getItem('moduleId');
        this.CSV = this.radios[0].value;
        const uploadID = sessionStorage.getItem('uploadID');
        this.cc.getCountry().subscribe((data) => {
            this.DataArr = data;
            this.ch.detectChanges();
        });
        if (uploadID && this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            this.retrieveDetails(uploadID);
        }
        this.setvalidatations();
        // console.log(this.formBuilderInfo);
        this.companyId = parseInt(sessionStorage.getItem("companyId"));
        if (this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            this.getSuppliers();
        }
    }
    setOrRemoveSessionStorageItem(key, value) {
        if (value !== null && value !== undefined) {
            sessionStorage.setItem(key, value);
        }
        else if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
        }
    }
    valueChange(e) {
        this.selected = e.target.value;
    }
    radiovalue() {
        if (this.CSV == 'CSV') {
            this.fileFlag = true;
            this.showEditForm = false;
        }
        else {
            this.fileFlag = false;
            this.showEditForm = true;
            this.isErrorEdit = false;
        }
        this.disableFileUpload = false;
    }
    FileUpload(event, mode) {
        const payload = new FormData();
        if (mode === 'single') {
            const file = event.files[0];
            payload.append('files', file);
            this.fileName = event.files[0].name;
            this.uploadedFiles = [];
        }
        else {
            for (let file of event.files) {
                this.uploadedFiles.push(file);
                payload.append('files', file);
            }
            this.fileName = '';
        }
        let param1;
        let param2;
        if (this.formBuilderInfo.formName !== 'Manage Suppliers' && this.formBuilderInfo.formName !== 'Onboarded Employee List') { // && this.formBuilderInfo.formName !== 'Onboarded Employee List'
            param1 = "talentpool";
            param2 = "resumes";
        }
        else if (this.formBuilderInfo.formName === 'Manage Suppliers') {
            param1 = "supplier";
            param2 = "supplierFile";
        }
        else if (this.formBuilderInfo.formName === 'Onboarded Employee List') {
            param1 = "employee";
            param2 = "employeeFile";
        }
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.uploadDocument(this.getModuleId, payload, param1, param2)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if ((response === null || response === void 0 ? void 0 : response.status) === 204 || (response === null || response === void 0 ? void 0 : response.status) === 500) {
                CustomErrorToastComponent.showErrorToast(this.toastr, response.message || "No records found in the uploaded document");
                this.getUploadFilesResponse = null;
                this.fileUpload.clear();
            }
            else {
                this.getUploadFilesResponse = (response === null || response === void 0 ? void 0 : response.data) || null;
                if (this.getUploadFilesResponse) {
                    this.getUploadId = this.formBuilderInfo.formName === 'Onboarded Employee List' ? this.getUploadFilesResponse.fbEmployeeBulkUploadId : this.getUploadFilesResponse.fbTPResumeBulkUploadId;
                    this.setOrRemoveSessionStorageItem('uploadID', this.getUploadId);
                    this.showSummary = true;
                    this.disableFileUpload = true;
                    this.toastr.success(response === null || response === void 0 ? void 0 : response.message, 'Success');
                }
            }
        });
    }
    hasEmailError() {
        var _a, _b;
        return (_b = (_a = this.getUploadFilesResponse) === null || _a === void 0 ? void 0 : _a.errorDetails) === null || _b === void 0 ? void 0 : _b.some(item => item.errorMessage); // === 'Email is already in use'
    }
    downloadTemplateFile() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.downloadTemplate()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
                this.bulkUploadDashboardService.downloadDocuments(path, "Resume Format");
            }
        });
    }
    downloadSupplierTemplateFile() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.downloadSupplierTemplate()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
                this.bulkUploadDashboardService.downloadDocuments(path, "Supplier Format");
            }
        });
    }
    downloadEmployeeTemplateFile() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.downloadEmployeeTemplate()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
                this.bulkUploadDashboardService.downloadDocuments(path, "Employee Format");
            }
        });
    }
    retrieveDetails(uploadID) {
        let param;
        let param2;
        if (this.formBuilderInfo.formName !== 'Manage Suppliers' && this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            param = "talentpool";
            param2 = "details";
        }
        else if (this.formBuilderInfo.formName === 'Manage Suppliers') {
            param = "supplier";
            param2 = "details";
        }
        else if (this.formBuilderInfo.formName === 'Onboarded Employee List') {
            param = "emloyee";
            param2 = "afterErrorDeletedetails";
        }
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.retrieveDocument(uploadID, param, param2)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            var _a;
            this.getUploadFilesResponse = response.data;
            if (((_a = this.getUploadFilesResponse) === null || _a === void 0 ? void 0 : _a.errorDetails) === null) {
                sessionStorage.removeItem("uploadID");
                /*  this.customButtonActionService.getPageFormById(this.formBuilderInfo.id)
             .pipe(take(1)).subscribe((response: any) => {
               if (response) {
                 const item = {
                   formType: response.buildFormatTypeId,
                   pageFormId: response.id
                 }
                 this.customButtonActionService.onLinkRedirectPageSubject.next(item);
               }
             }); */
                const item = {
                    formType: 1481,
                    // pageFormId: this.formBuilderInfo.formName !== 'Manage Suppliers' ? 267 : 384
                    pageFormId: this.formBuilderInfo.formName === 'Manage Suppliers' ? 384 :
                        this.formBuilderInfo.formName === 'Onboarded Employee List' ? 83 :
                            267
                };
                this.customButtonActionService.onLinkRedirectPageSubject.next(item);
            }
        });
    }
    editDocument(error) {
        const item = {
            formType: 1482,
            pageFormId: 276
        };
        this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        this.bulkUploadDashboardService.getErrorId = error.id;
        this.bulkUploadDashboardService.editFlowflag = 'bulk';
    }
    editSupplierDocument(error) {
        this.showEditForm = true;
        // const item = {
        //   formType: 1482,
        //   pageFormId: 386
        // }
        // this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        this.bulkUploadDashboardService.getErrorId = error.id;
        sessionStorage.setItem('isErrorEdit', String(true));
        this.bulkUploadDashboardService.editFlowflag = 'bulk';
        this.getEditId = this.bulkUploadDashboardService.getErrorId;
        this.isErrorEdit = true;
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.editErrorDocument(this.getEditId).subscribe((response) => {
            if (response.data) {
                this.getSupplierDetails = response.data;
                this.getParsingDetails();
            }
        });
    }
    editEmployeeDocument(error) {
        this.showEditForm = true;
        this.bulkUploadDashboardService.getErrorId = error.id;
        sessionStorage.setItem('isErrorEdit', String(true));
        this.bulkUploadDashboardService.editFlowflag = 'bulk';
        this.getEditId = this.bulkUploadDashboardService.getErrorId;
        sessionStorage.setItem('errorEditId', this.getEditId);
        this.isErrorEdit = true;
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.editEmpErrorDocument(this.getEditId).subscribe((response) => {
            if (response.data) {
                this.getEmployeeDetails = response.data;
            }
        });
    }
    getParsingDetails() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        this.supplierDetailsForm.get('supplierName').setValue(((_a = this.getSupplierDetails) === null || _a === void 0 ? void 0 : _a.supplierName) ? (_b = this.getSupplierDetails) === null || _b === void 0 ? void 0 : _b.supplierName : "");
        this.supplierDetailsForm.get('phoneNumber').setValue(((_c = this.getSupplierDetails) === null || _c === void 0 ? void 0 : _c.phoneNumber) ? (_d = this.getSupplierDetails) === null || _d === void 0 ? void 0 : _d.phoneNumber : "");
        let phoneCode = ((_e = this.getSupplierDetails) === null || _e === void 0 ? void 0 : _e.phoneCode) ? (_f = this.getSupplierDetails) === null || _f === void 0 ? void 0 : _f.phoneCode : "";
        if (phoneCode.startsWith("+")) {
            phoneCode = phoneCode.substring(1);
        }
        this.supplierDetailsForm.get('phoneCode').setValue(phoneCode);
        this.supplierDetailsForm.get('communicationEmailId').setValue(((_g = this.getSupplierDetails) === null || _g === void 0 ? void 0 : _g.communicationEmailId) ? (_h = this.getSupplierDetails) === null || _h === void 0 ? void 0 : _h.communicationEmailId : "");
        this.supplierDetailsForm.get('location').setValue(((_j = this.getSupplierDetails) === null || _j === void 0 ? void 0 : _j.location) ? (_k = this.getSupplierDetails) === null || _k === void 0 ? void 0 : _k.location : "");
    }
    saveUploadDetails() {
        let param;
        let payload;
        this.formUniqueName = 'bulkformuniqueName' in sessionStorage ? sessionStorage.getItem('bulkformuniqueName') : null;
        if (this.formBuilderInfo.formName !== 'Manage Suppliers' && this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            param = "talentpool";
        }
        else if (this.formBuilderInfo.formName === 'Manage Suppliers') {
            param = "supplier";
        }
        else if (this.formBuilderInfo.formName === 'Onboarded Employee List') {
            param = "employee";
        }
        if (this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            payload = {
                "supplierId": this.supplierId,
                "supplierName": this.supplierName
            };
        }
        else {
            payload = { "formUniqueName": this.formUniqueName };
        }
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.addApplicant(this.getUploadId, param, payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                const item = {
                    formType: 1481,
                    //pageFormId: this.formBuilderInfo.formName !== 'Manage Suppliers' ? 267 : 384
                    pageFormId: this.formBuilderInfo.formName === 'Manage Suppliers' ? 384 :
                        this.formBuilderInfo.formName === 'Onboarded Employee List' ? 83 :
                            267
                };
                this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                this.toastr.success(response === null || response === void 0 ? void 0 : response.message, 'Success');
            }
        });
    }
    saveSupplierData() {
        const formValues = this.supplierDetailsForm.value;
        const phoneCode = formValues.phoneCode;
        const phoneNumber = formValues.phoneNumber;
        const isErrorEdit = sessionStorage.getItem('isErrorEdit') === 'true';
        const payload = Object.assign(Object.assign({}, this.supplierDetailsForm.value), { supplierDetailsFrom: isErrorEdit ? "EDIT_BULKUPLOAD_SUPPLIER" : "SAVE_UPDATE_SUPPLIER_MANUALLY", id: isErrorEdit ? this.getEditId : 0, isDel: false, companyId: this.companyId });
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.addSupplier(payload)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response) {
                this.toastr.success(response.message, 'Success');
                if (isErrorEdit) {
                    this.showEditForm = false;
                    this.getUpdatedErrorTable();
                }
                else {
                    const item = {
                        formType: 1481,
                        pageFormId: 384
                    };
                    this.customButtonActionService.onLinkRedirectPageSubject.next(item);
                    this.toastr.success(response === null || response === void 0 ? void 0 : response.message, 'Success');
                }
            }
        });
    }
    saveEmployeeData() {
        const isErrorEdit = sessionStorage.getItem('isErrorEdit') === 'true';
        if (isErrorEdit) {
            this.showEditForm = false;
            this.getUpdatedEmpErrorTable();
        }
    }
    closeForm() {
        this.showEditForm = false;
    }
    getUpdatedErrorTable() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.getErrorEditDetails(this.getUploadId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                this.getUploadFilesResponse = (response === null || response === void 0 ? void 0 : response.data) || null;
            }
        });
    }
    getUpdatedEmpErrorTable() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.getEmpErrorEditDetails(this.getUploadId)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            if (response.data) {
                this.getUploadFilesResponse = (response === null || response === void 0 ? void 0 : response.data) || null;
            }
        });
    }
    deleteDocument(error) {
        let param;
        if (this.formBuilderInfo.formName !== 'Manage Suppliers' && this.formBuilderInfo.formName !== 'Onboarded Employee List') {
            param = "talentpool";
        }
        else if (this.formBuilderInfo.formName === 'Manage Suppliers') {
            param = "supplier";
        }
        else if (this.formBuilderInfo.formName === 'Onboarded Employee List') {
            param = "employee";
        }
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.deleteApplicant(error.id, param)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.getUploadFilesResponse = response.data;
            if (this.getUploadFilesResponse) {
                this.disableFileUpload = true;
                const uploadID = sessionStorage.getItem('uploadID');
                if (uploadID) {
                    this.retrieveDetails(uploadID);
                }
            }
        });
    }
    getSuppliers() {
        this.subscription[this.subscription.length] = this.bulkUploadDashboardService.getSupplierList()
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe(response => {
            if (response.status == 200) {
                this.supplierList = response.data;
            }
        });
    }
    onChangeSupplier(e) {
        this.selectedSupplier = e.value;
        const selectedSupplier = this.supplierList.find(supplier => supplier.supplierId === this.selectedSupplier);
        if (selectedSupplier) {
            this.supplierId = selectedSupplier.supplierId;
            this.supplierName = selectedSupplier.supplierName;
        }
    }
    setvalidatations() {
        this.supplierDetailsForm = this.supplierDetailsFormBuilder.group({
            supplierName: ['', [Validators.required, Validators.pattern('^[a-zA-Z]+( [a-zA-Z]+)*$')]],
            phoneNumber: ['', [Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\.0-9]*$')]],
            phoneCode: [''],
            communicationEmailId: ['', [Validators.required, Validators.email]],
            location: ['', [Validators.pattern('^[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$')]]
        });
    }
    clear() {
        this.getUploadFilesResponse.errorDetails = [];
    }
    deleteFile() {
        this.getUploadFilesResponse.errorDetails = [];
        this.disableFileUpload = false;
        this.showSummary = false;
        if (this.fileUpload) {
            this.fileUpload.clear();
        }
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
        this.subscription.forEach(sub => sub.unsubscribe());
    }
}
BulkUploadDashboardComponent.ɵfac = function BulkUploadDashboardComponent_Factory(t) { return new (t || BulkUploadDashboardComponent)(i0.ɵɵdirectiveInject(BulkUploadDashboardService), i0.ɵɵdirectiveInject(i2.CustomButtonActionService), i0.ɵɵdirectiveInject(i3.FormBuilder), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.CacheCountryListService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef)); };
BulkUploadDashboardComponent.ɵcmp = i0.ɵɵdefineComponent({ type: BulkUploadDashboardComponent, selectors: [["bulk-upload-dashboard"]], viewQuery: function BulkUploadDashboardComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 1);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.fileUpload = _t.first);
    } }, inputs: { formBuilderInfo: "formBuilderInfo", inputParams: "inputParams" }, decls: 17, vars: 13, consts: [[1, "row", "bulk_upload_container", "p-2"], ["class", "col-12", 4, "ngIf"], [1, "col-12", "upload_section", "pb-3", "mb-3"], ["class", "w-600", 4, "ngIf"], [1, "flex", "justify-content-center"], ["class", "flex flex-wrap gap-3", 4, "ngIf"], [1, "flex", "flex-wrap", "gap-3", "mr-4", "mb-3", "mt-3"], ["class", "item-label uploadLabel", 4, "ngIf"], ["name", "demo[]", "class", "bulk_upload pl-2", "chooseIcon", "pi pi-upload", "mode", "basic", "chooseLabel", "Upload", "accept", ".pdf, .doc,.docx", "customUpload", "true", 3, "multiple", "disabled", "auto", "onSelect", 4, "ngIf"], ["class", "bulk_upload pl-2", "chooseIcon", "pi pi-upload", "mode", "basic", "customUpload", "true", "name", "demo[]", "accept", ".csv", "chooseLabel", "Upload", 3, "disabled", "auto", "uploadHandler", 4, "ngIf"], [4, "ngIf"], ["class", "emp-edit-form", 4, "ngIf"], [1, "col-12"], [1, "w-600"], [1, "flex", "flex-wrap", "gap-3"], ["class", "mr-4 mb-3 mt-3", "name", "fileFormat", 3, "value", "label", "ngModel", "inputId", "ngModelChange", "onClick", 4, "ngFor", "ngForOf"], ["style", "cursor:pointer", 3, "click", 4, "ngIf"], ["class", "col-3 sup-dd", 4, "ngIf"], ["name", "fileFormat", 1, "mr-4", "mb-3", "mt-3", 3, "value", "label", "ngModel", "inputId", "ngModelChange", "onClick"], [2, "cursor", "pointer", 3, "click"], [1, "pi", "pi-download"], [1, "col-3", "sup-dd"], [1, "label-cls", "sup-label"], ["formControlName", "supplier", "optionLabel", "supplierName", "optionValue", "supplierId", "placeholder", "Select Supplier", 3, "options", "onChange"], [1, "item-label", "uploadLabel"], ["name", "demo[]", "chooseIcon", "pi pi-upload", "mode", "basic", "chooseLabel", "Upload", "accept", ".pdf, .doc,.docx", "customUpload", "true", 1, "bulk_upload", "pl-2", 3, "multiple", "disabled", "auto", "onSelect"], ["chooseIcon", "pi pi-upload", "mode", "basic", "customUpload", "true", "name", "demo[]", "accept", ".csv", "chooseLabel", "Upload", 1, "bulk_upload", "pl-2", 3, "disabled", "auto", "uploadHandler"], ["fileUpload", ""], [1, "header-divider"], [1, "form-header"], [1, "supplier-heading"], ["class", "close-icon", 3, "click", 4, "ngIf"], [3, "formGroup", "ngSubmit"], ["f", "ngForm"], [1, "row", "mt-2"], [1, "col-4"], [1, "label-cls", "text-label", "details-label"], ["type", "text", "pattern", "^[a-zA-Z ]*$", "formControlName", "supplierName", "placeholder", "Enter your supplier Name", 1, "im-input", 3, "ngClass"], ["class", "invalid-message", 4, "ngIf"], [1, "label-cls", "dd-label"], ["formControlName", "phoneCode", 1, "form-control", "mt-2", 2, "width", "102%", "margin-left", "3px", 3, "change"], [3, "value", 4, "ngFor", "ngForOf"], ["type", "text", "formControlName", "phoneNumber", "pattern", "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$", 1, "im-input", 3, "ngClass"], ["type", "text", "formControlName", "communicationEmailId", 1, "im-input", 3, "ngClass"], ["type", "text", "formControlName", "location", 1, "im-input", 3, "ngClass"], ["type", "submit", 1, "btn", "btn-success", "save-btn", 3, "disabled", "ngClass"], [1, "close-icon", 3, "click"], [1, "invalid-message"], [3, "value"], [1, "emp-edit-form"], [3, "employeeDetails", "formSaved"], [1, "col-12", "upload_summary", "mb-3"], [4, "ngFor", "ngForOf"], [1, "cards_section"], [1, "row"], [1, "total_uploaded", "mr-4"], [1, "success_uploaded", "mr-4"], [1, "failed_uploaded"], [1, "w-600", "mt-3", "mb-0"], [1, "error"], ["class", "clearAll", 3, "click", 4, "ngIf"], ["class", "col-12 uploaded_docs_table", 4, "ngIf"], ["pButton", "", "type", "button", "label", "SAVE", "title", "SELECT", 1, "m-3", 3, "disabled", "click"], ["class", "clear-btn btn_width btn btn-secondary button-width-icon-left mr-3", "type", "button", 3, "click", 4, "ngIf"], [1, "clearAll", 3, "click"], [1, "col-12", "uploaded_docs_table"], ["rowExpandMode", "single", "currentPageReportTemplate", "Showing {first} to {last} of {totalRecords} entries", "dataKey", "indexId", 3, "value", "tableStyle", "paginator", "rows", "showCurrentPageReport", "rowsPerPageOptions"], ["pTemplate", "header"], ["pTemplate", "body"], ["nowrap", ""], [1, "d-flex", "flex-row", "documents-icons", "d-flex", "align-items-center"], [1, "mr-2", "padding0"], ["pButton", "", "type", "button", "icon", "pi pi-pencil", "pTooltip", "Edit", 1, "p-button-text", "p-button-rounded", 3, "click"], ["pButton", "", "type", "button", "icon", "pi pi-trash", "pTooltip", "Delete", 1, "p-button-text", "p-button-rounded", 3, "click"], [3, "ngClass"], ["type", "button", 1, "clear-btn", "btn_width", "btn", "btn-secondary", "button-width-icon-left", "mr-3", 3, "click"]], template: function BulkUploadDashboardComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, BulkUploadDashboardComponent_div_1_Template, 3, 0, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, BulkUploadDashboardComponent_h6_3_Template, 2, 0, "h6", 3);
        i0.ɵɵtemplate(4, BulkUploadDashboardComponent_h6_4_Template, 2, 0, "h6", 3);
        i0.ɵɵtemplate(5, BulkUploadDashboardComponent_h6_5_Template, 2, 0, "h6", 3);
        i0.ɵɵelementStart(6, "div", 4);
        i0.ɵɵtemplate(7, BulkUploadDashboardComponent_div_7_Template, 4, 3, "div", 5);
        i0.ɵɵtemplate(8, BulkUploadDashboardComponent_div_8_Template, 3, 2, "div", 5);
        i0.ɵɵtemplate(9, BulkUploadDashboardComponent_div_9_Template, 3, 2, "div", 5);
        i0.ɵɵelementStart(10, "div", 6);
        i0.ɵɵtemplate(11, BulkUploadDashboardComponent_label_11_Template, 2, 0, "label", 7);
        i0.ɵɵtemplate(12, BulkUploadDashboardComponent_p_fileUpload_12_Template, 1, 3, "p-fileUpload", 8);
        i0.ɵɵtemplate(13, BulkUploadDashboardComponent_p_fileUpload_13_Template, 2, 2, "p-fileUpload", 9);
        i0.ɵɵtemplate(14, BulkUploadDashboardComponent_div_14_Template, 45, 26, "div", 10);
        i0.ɵɵtemplate(15, BulkUploadDashboardComponent_div_15_Template, 3, 2, "div", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, BulkUploadDashboardComponent_div_16_Template, 36, 13, "div", 10);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Manage Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Onboarded Employee List");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Manage Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Onboarded Employee List");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Manage Suppliers" && !ctx.showEditForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Onboarded Employee List" && !ctx.showEditForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Manage Suppliers" && (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Onboarded Employee List");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Manage Suppliers" && !ctx.showEditForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Onboarded Employee List" && !ctx.showEditForm);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Manage Suppliers" && !ctx.showEditForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) !== "Manage Suppliers" && !ctx.fileFlag);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.fileFlag && !ctx.showEditForm);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Manage Suppliers" && (!ctx.fileFlag || ctx.showEditForm));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.formBuilderInfo == null ? null : ctx.formBuilderInfo.formName) === "Onboarded Employee List" && ctx.showEditForm && ctx.getEmployeeDetails);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.disableFileUpload && !ctx.showEditForm && ctx.showSummary);
    } }, directives: [i6.NgIf, i6.NgForOf, i7.RadioButton, i3.NgControlStatus, i3.NgModel, i8.Dropdown, i3.FormControlName, i9.FileUpload, i3.ɵangular_packages_forms_forms_ba, i3.NgControlStatusGroup, i3.FormGroupDirective, i3.DefaultValueAccessor, i3.PatternValidator, i6.NgClass, i3.SelectControlValueAccessor, i3.NgSelectOption, i3.ɵangular_packages_forms_forms_z, i10.LibAddNewEmployeeComponent, i11.ButtonDirective, i12.Table, i13.PrimeTemplate, i14.Tooltip], styles: [".bulk_upload_container[_ngcontent-%COMP%]   .text-label[_ngcontent-%COMP%]{margin-left:5px;color:#000!important}.bulk_upload_container[_ngcontent-%COMP%]   .dd-label[_ngcontent-%COMP%]{color:#000!important;margin-left:2px}.bulk_upload_container[_ngcontent-%COMP%]   .save-btn[_ngcontent-%COMP%]{position:relative;top:92px;left:12px}.bulk_upload_container[_ngcontent-%COMP%]   .supplier-heading[_ngcontent-%COMP%]{font-weight:800;margin-bottom:22px}.bulk_upload_container[_ngcontent-%COMP%]   sup[_ngcontent-%COMP%]{color:#c54545}.bulk_upload_container[_ngcontent-%COMP%]   .error[_ngcontent-%COMP%]{color:#eb2934;max-width:100px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bulk_upload_container[_ngcontent-%COMP%]   .sup-error[_ngcontent-%COMP%]{color:#eb2934;max-width:100px;word-wrap:break-word}.bulk_upload_container[_ngcontent-%COMP%]   .no-error[_ngcontent-%COMP%]{color:#28a745;max-width:100px;word-wrap:break-word}.bulk_upload_container[_ngcontent-%COMP%]   .delete-file-btn[_ngcontent-%COMP%]{position:relative;right:14px}.bulk_upload_container[_ngcontent-%COMP%]   .form-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center}.bulk_upload_container[_ngcontent-%COMP%]   .sup-label[_ngcontent-%COMP%]{color:#333!important}.bulk_upload_container[_ngcontent-%COMP%]   .sup-dd[_ngcontent-%COMP%]{position:relative;right:12px;bottom:4px}.bulk_upload_container[_ngcontent-%COMP%]   .close-icon[_ngcontent-%COMP%]{cursor:pointer;font-size:18px;font-weight:700;color:#333;float:right}.bulk_upload_container[_ngcontent-%COMP%]   .clearAll[_ngcontent-%COMP%]{color:#00a0da;display:inline-block;float:right;cursor:pointer}.bulk_upload_container[_ngcontent-%COMP%]   .clear-btn[_ngcontent-%COMP%]{position:relative;bottom:16px}.bulk_upload_container[_ngcontent-%COMP%]   .bulk-head[_ngcontent-%COMP%]{display:block;font-weight:600;font-size:20px;margin-bottom:15px}.bulk_upload_container[_ngcontent-%COMP%]   .uploadLabel[_ngcontent-%COMP%]{vertical-align:text-bottom;font-weight:600}.bulk_upload_container[_ngcontent-%COMP%]   .uploaded_docs_table[_ngcontent-%COMP%]{border-bottom:1px dashed #7c7c7c}.bulk_upload_container[_ngcontent-%COMP%]   .upload_section[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#00a0da}.bulk_upload_container[_ngcontent-%COMP%]   .failed_uploaded[_ngcontent-%COMP%], .bulk_upload_container[_ngcontent-%COMP%]   .success_uploaded[_ngcontent-%COMP%], .bulk_upload_container[_ngcontent-%COMP%]   .total_uploaded[_ngcontent-%COMP%]{border-left:5px solid #00a0da;border-radius:5px;padding:5px;box-shadow:0 0 5px 1px #ccc}.bulk_upload_container[_ngcontent-%COMP%]   .failed_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child, .bulk_upload_container[_ngcontent-%COMP%]   .success_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child, .bulk_upload_container[_ngcontent-%COMP%]   .total_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:first-child{font-size:36px;font-weight:800;display:inline-block;margin-bottom:5px;margin-top:5px}.bulk_upload_container[_ngcontent-%COMP%]   .failed_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2), .bulk_upload_container[_ngcontent-%COMP%]   .success_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2), .bulk_upload_container[_ngcontent-%COMP%]   .total_uploaded[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]:nth-child(2){font-size:14px;padding-left:10px;width:55%;display:inline-block;font-weight:600;color:#4a4a4a;line-height:16px}.bulk_upload_container[_ngcontent-%COMP%]   .success_uploaded[_ngcontent-%COMP%]{border-left:5px solid #77cd6c}.bulk_upload_container[_ngcontent-%COMP%]   .failed_uploaded[_ngcontent-%COMP%]{border-left:5px solid #e80b18}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkUploadDashboardComponent, [{
        type: Component,
        args: [{
                selector: 'bulk-upload-dashboard',
                templateUrl: './bulk-upload-dashboard.component.html',
                styleUrls: ['./bulk-upload-dashboard.component.scss'],
            }]
    }], function () { return [{ type: BulkUploadDashboardService }, { type: i2.CustomButtonActionService }, { type: i3.FormBuilder }, { type: i4.ToastrService }, { type: i5.CacheCountryListService }, { type: i0.ChangeDetectorRef }]; }, { formBuilderInfo: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], fileUpload: [{
            type: ViewChild,
            args: ['fileUpload']
        }] }); })();

class BulkUploadDashboardModule {
}
BulkUploadDashboardModule.ɵfac = function BulkUploadDashboardModule_Factory(t) { return new (t || BulkUploadDashboardModule)(); };
BulkUploadDashboardModule.ɵmod = i0.ɵɵdefineNgModule({ type: BulkUploadDashboardModule });
BulkUploadDashboardModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            LibAddNewEmployeeModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(BulkUploadDashboardModule, { declarations: [BulkUploadDashboardComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        LibAddNewEmployeeModule], exports: [BulkUploadDashboardComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(BulkUploadDashboardModule, [{
        type: NgModule,
        args: [{
                declarations: [BulkUploadDashboardComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    LibAddNewEmployeeModule
                ],
                exports: [BulkUploadDashboardComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of bulk-upload-dashboard
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BulkUploadDashboardComponent, BulkUploadDashboardModule, BulkUploadDashboardService };
//# sourceMappingURL=bulk-upload-dashboard.js.map
